
  export const detailsAdapter = (detailsResponse: any): any => {
    //OFERTAS
    const transformedOffersData = detailsResponse?.offers?.map((item: any) => {
        const availableLangs = Object.keys(item);
        if (!availableLangs || availableLangs.length === 0) 
          return undefined;

        const groupedFields = Object.keys(item[availableLangs[0]]).reduce((acc: any, key) => {
          if (key !== 'start' && key !== 'end') {
            acc[key] = {};
            availableLangs.forEach(lang => {
              acc[key][lang] = item?.[lang]?.[key];
            });
          }
          return acc;
        }, {});
  
        groupedFields.start = item.es.start;
        groupedFields.end = item.es.end;
        return groupedFields;
    });
  
    //POINT COORDINATES
    const [lat, lng] = detailsResponse.coordinates ? detailsResponse.coordinates?.split(',') : [null, null];
  
    //POINT MULTIMEDIA (IMAGE, VIDEO SLIDER)
    const multimedia = detailsResponse.multimedia?.map(item => ({ name: item.name, type: item.type }));
  
    //ALL POINT BUTTONS
    let combinedActionButtonsArray = [];
    if (detailsResponse.links && !Array.isArray(detailsResponse.links)) {
      const linkButtons = getLinksButtons(detailsResponse.links);
      combinedActionButtonsArray = [...combinedActionButtonsArray, linkButtons];
    }
    if (detailsResponse.files && !Array.isArray(detailsResponse.files)) {
      const fileButtons = getFileButtons(detailsResponse.files);
      combinedActionButtonsArray = [...combinedActionButtonsArray, fileButtons];
    }

    const actionButtons = getCombinedActionButtons(combinedActionButtonsArray);
    const categoriesImg = detailsResponse?.category?.map(cat => cat.image);
  
    return {
      id: typeof detailsResponse.id === 'string' ? parseInt(detailsResponse.id) : detailsResponse.id,
      name: detailsResponse.name ?? null,
      categoryImage: detailsResponse?.category_image ?? detailsResponse?.category?.[0]?.image,
      categoriesImages: categoriesImg,
      description: detailsResponse.description?.length === 0 ? null : detailsResponse.description,
      routeData: {
        ...detailsResponse.route_data,
        duration: detailsResponse?.route_data?.duration ? { hours: Math.floor(detailsResponse.route_data.duration / 60), minutes: detailsResponse.route_data.duration % 60 } : null,
        warning: detailsResponse?.route_data?.warnings,
      },
      location: (lat && lng) || detailsResponse.location
        ? {
            lat: lat ? parseFloat(lat) : null,
            lng: lng ? parseFloat(lng) : null,
            address: detailsResponse.location ?? null,
          }
        : null,
      duration: parseDuration(detailsResponse?.durationc),
      schedule: detailsResponse.opening_times?.length === 0 ? null : detailsResponse.opening_times,
      photo_360: detailsResponse.photo_360,
      speaker: detailsResponse.speaker,
      action_buttons: actionButtons ?? null,
      multimedia: multimedia ?? null,
      extra_fields: detailsResponse.extra_fields?.length === 0 ? null : detailsResponse.extra_fields,
      price: detailsResponse.price ?? null,
      type: detailsResponse.type,
      related: Array.isArray(detailsResponse.related) ? detailsResponse.related : undefined,
      dateRange: detailsResponse.start &&  detailsResponse.end ? {start: detailsResponse.start, end: detailsResponse.end} : null,
      tags: detailsResponse.tags?.length === 0 ? null : detailsResponse.tags,
      accessibility: detailsResponse.accesibility?.length === 0 ? null : detailsResponse.accesibility,
      offers: transformedOffersData ?? null,
      audioguides: detailsResponse?.audioguides,
      audios: detailsResponse?.audios,
      relatedCategories: detailsResponse?.selected_hiking_categories,
      relatedItems: (detailsResponse?.relatedItems ?? [])?.map(hiking => ({
        ...hiking,
        location: { 
          lat: Number(hiking.location.latitude),
          lng: Number(hiking.location.longitude)
        }
      })),
      relatedCategoryItems: (detailsResponse?.hiking_categories ?? [])?.map(hiking => ({
        ...hiking,
        location: {
          lat: Number(hiking.location.latitude),
          lng: Number(hiking.location.longitude)
        }
      }))?.filter(hiking =>
        !(detailsResponse?.relatedItems ?? []).some(
          e => e.id === hiking.id && e.type === hiking.type
        )
      ),
      rating: {
        average: detailsResponse?.valoration_average ?? null,
        count: detailsResponse?.valoration_total_votes ?? 0,
        userRating: detailsResponse?.valoration_user_score ?? null,
      },
    };
  };
  
  
  function getCombinedActionButtons(buttonsArray: any[]) {
    if (buttonsArray.length === 0) 
      return null;

    let combinedActionButtons = {};
    const allKeys = new Set(buttonsArray.flatMap(buttons => Object.keys(buttons)));
    allKeys?.forEach(key => {
      const combinedButtons = [];
      buttonsArray.forEach(buttons => {
        if (buttons?.[key]) 
            combinedButtons.push(...buttons[key]);
      });
      if (combinedButtons.length > 0) 
        combinedActionButtons[key] = combinedButtons;
    });
    if (Object.keys(combinedActionButtons).length === 0) 
      return null;

    return combinedActionButtons;
  }
  
  function getLinksButtons(items: any) {
    let actionButtons = Object.keys(items)?.reduce((acc: any, key) => {
        if (items?.[key]) {
            const buttons = items?.[key]?.map((button: any) => {
                let buttonType = '';
                switch (button.show) {
                    case 'qr': buttonType = 'qr'; break;
                    case 'iframe': buttonType = 'iframe'; break;
                    case 'iframe_full': buttonType = 'iframe_full'; break;
                    case 'link': buttonType = 'link'; break;
                }
    
                return {
                    button_text: button.button_text,
                    url: button.link,
                    type: buttonType,
                };
            });

          acc[key] = buttons;
        }
        return acc;
      },{}
    );
    return actionButtons;
  }
  
  function getFileButtons(items: any) {
    let actionButtons = Object.keys(items)?.reduce((acc: any, key) => {
        const buttons = items?.[key]?.map((button: any) => {
          let type = 'link';
          if (button.type === 'application/pdf')
            type = 'pdf';
          //HRS-2919: los audios llegan por el campo audios (panel de audios);
          //se conserva comentado por si hubiera que recuperarlo.
          //else if (button.type?.startsWith('audio'))
          //  type = 'audio';

          return {
            button_text: button.text_button,
            url: button.src,
            type,
          }
        });
        acc[key] = buttons;
        return acc;
      },
      {}
    );
    return actionButtons;
  }

  function parseDuration(raw: string | null | undefined): { hours: number; minutes: number } | null {
    if (!raw) return null;
    const match = raw.match(/(?:(\d+)h[.\s]*)?\s*(?:(\d+)m[.\s]*)?/);
    if (!match) return null;
    const hours = match[1] ? parseInt(match[1], 10) : 0;
    const minutes = match[2] ? parseInt(match[2], 10) : 0;
    if (hours === 0 && minutes === 0) return null;
    return { hours, minutes };
  }
  
